import BenefitSettingPage from "../components/page/BenefitSettingPage";

const BenefitEdit = () => {
  return (
      <BenefitSettingPage />
  );
};
export default BenefitEdit;
